var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.currentUser.profile.interface === 'Worker')?_c('worker-home'):_c('requester-home')}
var staticRenderFns = []

export { render, staticRenderFns }